document.addEventListener('DOMContentLoaded', function () {
  navBarDarkBackgroundChange();
  navBarCollapseToggle();
  initVideoDummyImage();
});

function initVideoDummyImage() {
  const videoElement = document.getElementById('kk-home-video');
  if (videoElement) {
    videoElement.addEventListener('canplaythrough', playVideoWhenDownloaded);
    videoElement.load();
  }
}

function playVideoWhenDownloaded(event) {
  const videoElement = document.getElementById('kk-home-video');
  if (videoElement) {
    videoElement.play();
  }
}

function navBarDarkBackgroundChange() {
  ScrollTrigger.create({
    trigger: '.kk-below-the-video-section',
    start: 'top top+=110',
    end: 'bottom+=1000 top',
    toggleClass: {
      targets: '.kk-new-design-header .navbar',
      className: 'kk-dark-bg-dynamic'
    }
    //markers: true
  });
}

function navBarCollapseToggle() {
  const collapseMenu = document.getElementById('navbar');
  if (collapseMenu) {
    collapseMenu.addEventListener('hidden.bs.collapse', function () {
      const kkMainHeader = document.getElementById('kk-main-header');
      kkMainHeader.classList.toggle('kk-dd-menu-expanded');
    });
    collapseMenu.addEventListener('show.bs.collapse', function () {
      const kkMainHeader = document.getElementById('kk-main-header');
      kkMainHeader.classList.toggle('kk-dd-menu-expanded');
    });
  }
}
